import { SxProps, Theme } from "@mui/material";

// Common style objects for DrawdownComparisonChart
export const drawdownComparisonChartStyles = {
  // Card container styles
  card: {
    padding: 2,
    cursor: "pointer",
    backgroundColor: "white",
    borderRadius: 2,
    border: "1px solid #E0E0E0",
    "&:hover": {
      boxShadow: 4,
    },
  } as SxProps<Theme>,

  // Title container styles
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  } as SxProps<Theme>,

  // Title line 1 styles
  titleLine1: {
    color: "#2C8BB0",
    fontSize: "1rem",
    fontWeight: 500,
    fontFamily: '"Poppins", sans-serif',
    lineHeight: 1.2,
    marginBottom: 0,
  } as SxProps<Theme>,

  // Title line 2 styles
  titleLine2: {
    color: "#2C8BB0",
    fontSize: "1rem",
    fontWeight: 500,
    fontFamily: '"Poppins", sans-serif',
    lineHeight: 1.2,
    marginTop: 0,
  } as SxProps<Theme>,

  // Bars container styles
  barsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  } as SxProps<Theme>,

  // Bar row container styles
  barRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: 1.5,
  } as SxProps<Theme>,

  // Bar label styles
  barLabel: {
    minWidth: 80,
    color: "#003057",
    fontSize: "0.875rem",
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
  } as SxProps<Theme>,

  // Bar container styles (unfilled background) - highly rounded
  barContainer: {
    flex: 1,
    height: 24,
    backgroundColor: "#F5F5F5",
    borderRadius: "12px", // Highly rounded for pill shape
    position: "relative",
    overflow: "hidden",
    marginRight: 2,
  } as SxProps<Theme>,

  // Bar Stock filled portion styles - highly rounded
  barStockFilled: {
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    backgroundColor: "#2C8BB0",
    borderRadius: "12px", // Highly rounded for pill shape on all sides
    borderTopRightRadius: "12px",
    borderBottomRightRadius: "12px",
    transition: "width 0.3s ease",
  } as SxProps<Theme>,

  // Bar OEA filled portion styles - highly rounded
  barOeaFilled: {
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    backgroundColor: "#003057",
    borderRadius: "12px", // Highly rounded for pill shape on all sides
    borderTopRightRadius: "12px",
    borderBottomRightRadius: "12px",
    transition: "width 0.3s ease",
  } as SxProps<Theme>,

  // Bar Stock value styles
  barStockValue: {
    color: "#2C8BB0",
    fontWeight: 500,
    minWidth: 70,
    textAlign: "right",
    fontSize: "0.875rem",
    fontFamily: '"Poppins", sans-serif',
  } as SxProps<Theme>,

  // Bar OEA value styles
  barOeaValue: {
    color: "#003057",
    fontWeight: 500,
    minWidth: 70,
    textAlign: "right",
    fontSize: "0.875rem",
    fontFamily: '"Poppins", sans-serif',
  } as SxProps<Theme>,
};

// Modal styles
export const drawdownComparisonEditModalStyles = {
  // Modal container styles
  modalContainer: {
    width: "500px",
  } as SxProps<Theme>,

  // Form buttons container styles
  buttonsContainer: {
    display: "flex",
    gap: 1,
    margin: 1,
  } as SxProps<Theme>,

  // Button styles
  button: {
    flex: 1,
  } as SxProps<Theme>,
};
